export default class MyCompany {
    constructor(element) {
        this.myCompany = element

        this.myCompany.addEventListener('paste', function (e) {
            var content = e.clipboardData.getData('text/plain');
            document.execCommand('insertText', false, content);
            e.preventDefault();
            return false;
        });

        // Category and subcategories
        this.category = this.myCompany.querySelector('.company_category')
        this.form = this.myCompany.querySelector('form')
        this.url = this.form.action
        this.subCategories = this.myCompany.querySelector('.company-subcategories')
        this.subCategoriesSelected = JSON.parse(this.subCategories.getAttribute('data-subcategories'))
        this.subCategoryLoader = this.myCompany.querySelector('.company-subcategories-loader')
        this.startSubCategoryLoading()

        this.category.addEventListener('change', (event) => {
            event.preventDefault()
            this.handleCategoryChange()
        })
        this.handleCategoryChange()

        // Image upload field
        this.fileUpload = this.myCompany.querySelector('.my-company-thumbnail')
        this.fileUpload.addEventListener('change', () => { this.handleFileUploadChange() })

        // Image upload gallery
        this.galleryUploadInput = this.myCompany.querySelector('.my-company-gallery')
        this.galleryUploadInput.addEventListener('change', () => { this.handleGalleryUploadChange() })
        this.galleryImageIds = this.myCompany.querySelector('.my-company-gallery-ids')
        this.galleryPreview = this.myCompany.querySelector('.my-company-gallery-preview')

        this.galleryDeleteImages = this.myCompany.querySelectorAll('.my-company-gallery-delete-image')
        for(const delete_image of this.galleryDeleteImages) {
            delete_image.addEventListener('click', () => this.handleDeleteClick(delete_image))
        }

        // WYSIWYG
        this.wysiwygFields = this.myCompany.querySelectorAll('[data-tiny-editor]')
        this.wysiwygInput = this.myCompany.querySelector('.my-company-description')
        this.wysiwygFields.forEach(editor =>
            editor.addEventListener('input', e => this.handleWysiwygInput(e)
            ))

    }

    // Category and subcategories
    handleCategoryChange() {
        this.subCategories.style.display = "flex"
        this.removeInputFields()
        this.startSubCategoryLoading()

        fetch(this.getFullUrl(), {
            headers: {'Content-Type': 'application/json'},
        })
            .then(response => this.handleResponse(response))

    }

    getFullUrl() {
        const action = "my_company_get_filters"
        const ajaxNonce = this.getAjaxNonceGetFilters()
        const category = this.getCategory()
        return `/wp-admin/admin-ajax.php?action=${action}&_ajax_nonce=${ajaxNonce}&category=${category}`
    }

    getAjaxNonceGetFilters() {
        return this.form.querySelector('input[name="_ajax_nonce_filters"]').value
    }

    getCategory() {
        return this.form.querySelector('.company_category').value
    }

    handleResponse(response) {
        response.json().then(data => this.displaySubCategories(data))
    }

    displaySubCategories(data) {
        this.stopSubCategoryLoading()
        if (data.length) {
            this.displayInputFields(data)
            this.subCategories.style.display = "flex"
        }
        else {
            this.subCategories.style.display = "none"
        }
    }

    removeInputFields() {
        let subCategoryFilters = this.subCategories.querySelectorAll('.company-subcategory-filter')
        for(let subCategoryFilter of subCategoryFilters) {
            subCategoryFilter.remove()
        }
    }

    displayInputFields(inputs) {
        for(const input of inputs) {
            const checked = this.subCategoriesSelected.includes(input['term_id'])
            this.addInput(input, checked)
        }
    }

    addInput(input, checked = false) {
        let div = document.createElement('div')
        div.setAttribute('class', 'company-subcategory-filter')
        this.subCategories.appendChild(div)

        let inputElement = document.createElement('input')
        inputElement.setAttribute('type', 'checkbox')
        inputElement.setAttribute('id', input['slug'])
        inputElement.setAttribute('name', "company_subcategory[]")
        inputElement.setAttribute('value', input['slug'])
        if (checked) {
            inputElement.setAttribute('checked', "checked")
        }
        div.appendChild(inputElement)

        let labelElement = document.createElement('label')
        labelElement.setAttribute('for', input['slug'])
        labelElement.innerHTML = input['name']
        div.appendChild(labelElement)
    }

    stopSubCategoryLoading() {
        this.subCategoryLoader.style.display = "none"
    }

    startSubCategoryLoading() {
        this.subCategoryLoader.style.display = "block"
    }

    // Image upload
    handleFileUploadChange() {
        const file = this.myCompany.querySelector('.my-company-thumbnail').files[0]

        if (!this.isFileSizeUnderLimit(file)) {
            this.handleFileTooLarge()
            return
        }

        const fr = new FileReader()
        fr.readAsDataURL(file)
        fr.onload = function(e) {
            let img = document.getElementById('image_preview')
            img.src = this.result
        }
    }

    // Image upload gallery
    handleGalleryUploadChange() {
        if(!this.isFileSizeUnderLimit(this.galleryUploadInput.files[0])) {
            this.handleFileTooLarge()
            return
        }

        if (!this.isNumberFilesUnderLimit()) {
            this.handleTooManyFiles()
            return
        }

        let formData = new FormData()
        this.galleryUploadInput.classList.add('loading')
        this.galleryUploadInput.disabled = true
        formData.append('image', this.galleryUploadInput.files[0])
        fetch(this.getGalleryUploadUrl(), {
            method: 'POST',
            body: formData,
            headers: {

            },
        })
            .then(response => this.handleGalleryUploadResponse(response))
    }

    handleGalleryUploadResponse(response) {
        response.json().then(data => this.updateGallery(data))
        this.galleryUploadInput.classList.remove('loading')
        this.galleryUploadInput.disabled = false
    }

    updateGallery(data) {
        let imageIds = this.galleryImageIds.value ? this.galleryImageIds.value.split(',') : []
        imageIds.push(data['id'])
        this.galleryImageIds.value = imageIds.join(',')

        let imageUrls = this.galleryImageIds.getAttribute('data-images') ? this.galleryImageIds.getAttribute('data-images').split(',') : []
        imageUrls.push(data['url'])
        this.galleryImageIds.setAttribute('data-images', imageUrls.join(','))

        this.renderGalleryImages()
    }

    renderGalleryImages() {
        const imageIds = this.galleryImageIds.value ? this.galleryImageIds.value.split(',') : []
        const imageUrls = this.galleryImageIds.getAttribute('data-images') ? this.galleryImageIds.getAttribute('data-images').split(',') : []

        this.galleryPreview.innerHTML = ""
        for(let i = 0; i < imageIds.length; i++) {
            let delete_image = document.createElement('div')
            delete_image.classList.add('my-company-gallery-delete-image')
            delete_image.addEventListener('click', () => { this.handleDeleteClick(delete_image)})
            delete_image.setAttribute('data-image-index', i.toString())

            let new_image = document.createElement('img')
            new_image.src = imageUrls[i]

            let new_list_item = document.createElement('li')
            const list_item = this.galleryPreview.appendChild(new_list_item)
            list_item.appendChild(new_image)
            list_item.appendChild(delete_image)
        }
    }

    handleDeleteClick(image) {
        const index = image.getAttribute('data-image-index')
        let imageIds = this.galleryImageIds.value.split(',')
        imageIds.splice(index, 1)
        this.galleryImageIds.value = imageIds.join(',')

        let imageUrls = this.galleryImageIds.getAttribute('data-images').split(',')
        imageUrls.splice(index, 1)
        this.galleryImageIds.setAttribute('data-images', imageUrls.join(','))

        this.renderGalleryImages()
    }

    getGalleryUploadUrl() {
        const action = "my_company_upload_images"
        const ajaxNonce = this.form.querySelector('input[name="_ajax_nonce_gallery"]').value

        return `/wp-admin/admin-ajax.php?action=${action}&_ajax_nonce=${ajaxNonce}`
    }

    // Helper functions for both image upload fields
    handleFileTooLarge() {
        alert('De afbeelding die u probeert te uploaden is te groot.')
    }

    isNumberFilesUnderLimit() {
        const arrayImages = this.galleryImageIds.getAttribute('data-images').split(',')
        return arrayImages.length < 5
    }

    isFileSizeUnderLimit(file) {
        return file.size < 1024 * 1024 * 10
    }

    handleTooManyFiles() {
        alert('U kan maar 5 afbeeldingen uploaden.')
    }

    // WYSIWYG
    handleWysiwygInput(e) {
        this.wysiwygInput.value = e.target.innerHTML
        console.log(this.wysiwygInput.value)
    }


}